"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.NotificationsActions = void 0;

/**
 * Actions have a type that where the name will show up in logs.
 */
var NotificationsActions;
exports.NotificationsActions = NotificationsActions;

(function (NotificationsActions) {
  NotificationsActions["showDialog"] = "@app/notifications/dialog/show";
  NotificationsActions["dialogSubmitted"] = "@app/notifications/dialog/submitted";
  NotificationsActions["dialogCanceled"] = "@app/notifications/dialog/canceled";
  NotificationsActions["showCardNotificationPanel"] = "@app/notifications/panel/show";
})(NotificationsActions || (exports.NotificationsActions = NotificationsActions = {}));